import React, { useState } from 'react';
import { Modal, Select, Button, Typography } from 'antd';
import { ExternalLink, X } from 'lucide-react';

const { Text } = Typography;

const MoveToListModalV2 = ({ isOpen, onClose, onSave, tabs, recordName }) => {
  const [selectedTab, setSelectedTab] = useState(null);

  const handleSave = () => {
    if (!selectedTab) return;
    onSave(selectedTab);
  };

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <ExternalLink size={20} className="text-emerald-600" />
          <span className="text-lg font-bold text-slate-800">Move To Other List</span>
        </div>
      }
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose} className="rounded-xl font-bold h-10 px-6">
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleSave}
          disabled={!selectedTab}
          className="rounded-xl font-bold h-10 px-8 bg-emerald-600 hover:bg-emerald-700 shadow-lg shadow-emerald-200 border-none"
        >
          Move
        </Button>
      ]}
      width={450}
      className="premium-modal"
      closeIcon={<X size={20} className="text-slate-400 hover:text-slate-600" />}
      centered
    >
      <div className="py-4 space-y-4">
        <div className="p-4 bg-emerald-50 border border-emerald-100 rounded-2xl">
          <Text className="text-emerald-800 font-medium block">
            Moving record: <span className="font-bold">{recordName}</span>
          </Text>
        </div>

        <div className="space-y-2">
          <label className="text-[11px] font-black text-slate-500 block uppercase tracking-widest">
            Select Destination List
          </label>
          <Select
            className="w-full h-12 premium-select"
            placeholder="Choose a list to move to"
            onChange={setSelectedTab}
            options={tabs.filter(tab => tab.name).map(tab => ({
              label: tab.text,
              value: tab.name
            }))}
            getPopupContainer={() => document.body}
            virtual={false}
          />
        </div>
      </div>
    </Modal>
  );
};

export default MoveToListModalV2;
